import React, { useState, useEffect } from "react";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import CountUp from "react-countup";
import {
  doctor_dashboard_02,
  doctor_dashboard_04,
  morning_img_02,
  sorticon,
} from "../../imagepath";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import RadialPatientsChart from "./DonutChart";
import { Link, useNavigate } from "react-router-dom";
import ActivityChart from "./ActivityChart";
import MarketAreaChart from "./IncomeChart";
import teleChatApi from "../../../api/telechat.api";
import { Spin, message } from "antd";

const Doctor_Dashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [activeChats, setActiveChats] = useState([]);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const [dashboardStats, chats] = await Promise.all([
        teleChatApi.getDoctorDashboardStats(),
        teleChatApi.getDoctorChats(['PENDING_APPROVAL', 'ACTIVE']),
      ]);
      setStats(dashboardStats);
      setActiveChats((chats || []).slice(0, 5)); // Show only first 5
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      message.error('Грешка при зареждане на данните');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    // Backend sends LocalDateTime without timezone offset - treat as UTC, display in Sofia
    const utcDateString = dateString.endsWith('Z') ? dateString : dateString + 'Z';
    const date = new Date(utcDateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Току-що';
    if (diffMins < 60) return `преди ${diffMins} мин`;
    if (diffHours < 24) return `преди ${diffHours} ч`;
    if (diffDays < 7) return `преди ${diffDays} дни`;
    return date.toLocaleDateString('bg-BG', { timeZone: 'Europe/Sofia' });
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'PENDING_APPROVAL':
        return <span className="badge bg-warning text-dark">Чака одобрение</span>;
      case 'ACTIVE':
        return <span className="badge bg-success">Активен</span>;
      default:
        return <span className="badge bg-secondary">{status}</span>;
    }
  };

  if (loading) {
    return (
      <>
        <Header />
        <Sidebar
          id="menu-item"
          id1="menu-items"
          activeClassName="doctor-dashboard"
        />
        <div className="page-wrapper">
          <div className="content">
            <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
              <Spin size="large" />
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <Sidebar
        id="menu-item"
        id1="menu-items"
        activeClassName="doctor-dashboard"
      />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Табло </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Лекарско табло</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="good-morning-blk">
              <div className="row">
                <div className="col-md-6">
                  <div className="morning-user">
                    <h2>Здравейте</h2>
                    <p>Желаем ви приятен работен ден</p>
                  </div>
                </div>
                <div className="col-md-6 position-blk">
                  <div className="morning-img">
                    <img src={morning_img_02} alt="" />
                  </div>
                </div>
              </div>
            </div>

            {/* Stats Cards */}
            <div className="doctor-list-blk">
              <div className="row">
                <div className="col-xl-6 col-md-6">
                  <div className="doctor-widget border-right-bg">
                    <div className="doctor-box-icon flex-shrink-0">
                      <img src={doctor_dashboard_02} alt="" />
                    </div>
                    <div className="doctor-content dash-count flex-grow-1">
                      <h4>
                        <CountUp delay={0.4} end={stats?.activeChats || 0} duration={0.6} />
                        <span className="counter-up" style={{ margin: 0, marginLeft: 4 }}> / {stats?.totalChats || 0}</span>
                        <span style={{ display: 'none' }}></span>
                      </h4>
                      <h5>Консултации (Активни / Общо)</h5>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-md-6">
                  <div className="doctor-widget">
                    <div className="doctor-box-icon flex-shrink-0">
                      <img src={doctor_dashboard_04} alt="" />
                    </div>
                    <div className="doctor-content dash-count flex-grow-1">
                      <h4>
                        <CountUp delay={0.4} end={stats?.incomeThisMonth || 0} duration={0.6} decimals={2} />
                        <span className="counter-up" style={{ margin: 0, marginLeft: 4 }}> EUR</span>
                        <span style={{ display: 'none' }}></span>
                      </h4>
                      <h5>Приходи този месец</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Charts Row */}
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12 col-xl-7">
                <div className="card">
                  <div className="card-body">
                    <div className="chart-title patient-visit mb-0">
                      <h4>Приходи (последни 12 месеца)</h4>
                      <div className="income-value">
                        <h3>
                          {(stats?.totalIncome || 0).toFixed(2)} EUR
                        </h3>
                        <p className="text-muted">Общо приходи</p>
                      </div>
                    </div>
                    <MarketAreaChart monthlyStats={stats?.monthlyStats || []} />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-6 col-xl-3 d-flex">
                <div className="card">
                  <div className="card-body">
                    <h5 className="mb-3">Пациенти</h5>
                    <RadialPatientsChart
                      totalPatients={stats?.totalPatients || 0}
                      newPatientsThisMonth={stats?.newPatientsThisMonth || 0}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-6 col-xl-2 d-flex">
                <div className="struct-point">
                  <div className="card patient-structure">
                    <div className="card-body">
                      <h5>Нови пациенти</h5>
                      <h3>
                        {stats?.newPatientsThisMonth || 0}
                        <span className="status-green">
                          <img src={sorticon} alt="" className="me-1" />
                          този месец
                        </span>
                      </h3>
                    </div>
                  </div>
                  <div className="card patient-structure">
                    <div className="card-body">
                      <h5>Общо пациенти</h5>
                      <h3>{stats?.totalPatients || 0}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Activity Chart & Active Chats */}
            <div className="row">
              <div className="col-12 col-md-12 col-xl-7">
                <div className="card">
                  <div className="card-body">
                    <div className="chart-title patient-visit">
                      <h4>Консултации по месеци</h4>
                    </div>
                    <ActivityChart monthlyStats={stats?.monthlyStats || []} />
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-12 col-xl-5 d-flex">
                <div className="card flex-fill comman-shadow">
                  <div className="card-header">
                    <h4 className="card-title d-inline-block">
                      Активни консултации
                    </h4>
                    <Link
                      to="/doctor/telechat"
                      className="patient-views float-end"
                    >
                      Покажи всички
                    </Link>
                  </div>
                  <div className="card-body p-0">
                    {!Array.isArray(activeChats) || activeChats.length === 0 ? (
                      <div className="text-center py-4 text-muted">
                        <FeatherIcon icon="message-circle" size={40} className="mb-2" />
                        <p>Няма активни консултации</p>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table mb-0 border-0 custom-table">
                          <tbody>
                            {activeChats.map((chat) => (
                              <tr
                                key={chat.chatId}
                                style={{ cursor: 'pointer' }}
                                onClick={() => navigate(`/doctor/telechat/${chat.chatId}`)}
                              >
                                <td className="table-image appoint-doctor">
                                  <div
                                    className="rounded-circle d-flex align-items-center justify-content-center"
                                    style={{
                                      width: 36,
                                      height: 36,
                                      background: 'linear-gradient(135deg, #2e37a4 0%, #00d4ff 100%)',
                                      color: 'white',
                                      fontSize: '14px',
                                      fontWeight: 600,
                                    }}
                                  >
                                    {chat.patient?.fullName?.charAt(0) || 'П'}
                                  </div>
                                  <h2 className="ms-2">{chat.patient?.fullName || 'Пациент'}</h2>
                                </td>
                                <td className="appoint-time text-center">
                                  {getStatusBadge(chat.status)}
                                  <div className="mt-1">
                                    <small className="text-muted">
                                      {formatDate(chat.lastMessageAt || chat.createdAt)}
                                    </small>
                                  </div>
                                </td>
                                <td className="text-end">
                                  {chat.unreadCount > 0 && (
                                    <span className="badge bg-danger rounded-pill">
                                      {chat.unreadCount}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Doctor_Dashboard;
